import React, { PureComponent } from "react";
import PageLink from "../../Page/PageLink";
import Footer from "../../Footer/Footer";
import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Record_read extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_record_read">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Record.read</h2>
              <p>
                NL.Record.read allows you to read custom and system records from
                the Application and Workflow events.
              </p>
              <WorkflowCompatibility front={true} back={true} />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Option</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">system_record</td>
                    <td>
                      System object like user, group, workflow etc.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Record.read Example</h2>
              <p>This example reads an incident record.</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">type</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonA">"</span>
                  <span className="jsonG">incident</span>
                  <span className="jsonA">";</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">id</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonA">"</span>
                  <span className="jsonG">354</span>
                  <span className="jsonA">";</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">system_record</span>
                  <span className="jsonA">: </span>
                  <span className="jsonO">false</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Record</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">read</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">type</span>
                  <span className="jsonA">, </span>
                  <span className="nodeCode">id</span>
                  <span className="jsonA">, </span>
                  <span className="nodeCode">options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>

                <div className="i1">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Failed</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Success</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>

                <div>
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Record_read;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Record_read.js